<template>
  <div class="Cart-Receipt__Note">
    <div class="Cart-Receipt__Note-Toggle">
      <label class="p5" @click="toggle">
        <input
          id="giftNoteCheckbox"
          type="checkbox"
          v-model="checked"
          name="note-checkbox"
        />
        <span>
          {{ store.terms.note.message }}
        </span>
      </label>
    </div>
    <div
      class="Cart-Receipt__Note-Input gift-note-text-wrapper"
      :class="{ 'Cart-Receipt__Note-Input--Active': open }"
    >
      <textarea
        :maxlength="limit"
        v-model="message"
        @input="onInput"
        class="p2"
        :class="{ active: open }"
        :placeholder="store.terms.note.placeholder"
        aria-label="Gift Note"
      ></textarea>
      <p
        class="Cart-Receipt__Note-Counter p6"
        :class="{ active: ready, visible: open }"
      >
        {{ remainingCharacters }}
      </p>
      <button
        role="button"
        type="button"
        class="Cart-Receipt__Note-Submit btn add ready"
        @click="handleClick"
        :class="{ active: ready, visible: open }"
      >
        {{ store.terms.note.cta }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useCartStore } from './Composables/Store';

const store = useCartStore();
const checked = ref(false);
const open = ref(false);
const limit = ref(250);
const note = ref('');
const ready = ref(false);
const message = ref('');

const remainingCharacters = computed(() => {
  const remainder = limit.value - note.value.length;
  return `${remainder} / ${limit.value}`;
});

const toggle = () => {
  if (store.hasNote) {
    checked.value = true;
  } else {
    checked.value = !checked.value;
  }
  open.value = !open.value;
};

const onInput = () => {
  message.value = message.value.replace(/[^a-zA-Z0-9'!,. ]/g, '');
  note.value = message.value;
  ready.value = note.value.length > 0;
};
const handleClick = () => {
  note.value = note.value
    .replace(/'/g, '’')
    .replace(/\r?\n|\r/g, ' ')
    .trim();
  return store.addGiftNote(note.value);
};

const handleUI = () => {
  open.value = false;
  ready.value = store.hasNote;
  checked.value = store.hasNote;
  message.value = store.$state.note;
  note.value = store.$state.note;
};

watch(() => store.$state.note, handleUI, { immediate: true });
</script>
